export default __webpack_public_path__ + "static/media/mapPin.4b028c2f.svg";